export const SimulationDetailsDefaultTitles = [
  'Simulation Overview',
  'About the Persona',
  'Scoring Criteria',
];
